// extracted by mini-css-extract-plugin
export default {"login":"Login_login__3cJrA","login__popover":"Login_login__popover__oyd6b","login__text":"Login_login__text__uOIFS"};